<template>
  <v-dialog v-model="modal" max-width="500px">
    <v-card>
      <v-card-title>Signature Required</v-card-title>
      <v-card-text>
        <div>
          <option-signature
            :formId="selectedForm.id"
            @signature-generated="handleSignature"
            @signature-cleared="clearSignature"
            :question="signatureQuestion || {}"
            :label="signatureQuestion.title || ''"
          />
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          depressed
          :loading="buttonProgress"
          :disabled="!signature.url"
          color="primary"
          @click="submit"
          class="ma-3"
          >Complete</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import OptionSignature from '@/components/options/OptionSignature'

export default {
  components: {
    OptionSignature
  },
  data() {
    return {
      modal: false,
      selectedReason: '', //
      buttonProgress: false,
      signature: {
        modal: false,
        file: null,
        presignedURL: null,
        url: null
      }
    }
  },
  props: {
    isSignatureRequired: {
      type: Boolean,
      required: true
    },
    signatureQuestion: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      selectedForm: 'form/selectedForm',
      selectedSubmission: 'form/selectedSubmission',
      selectedSubmissionSection: 'form/selectedSubmissionSection'
    })
  },

  methods: {
    openSubmitModal() {
      this.modal = true
    },

    handleSignature(signature) {
      this.signature.file = signature.file
      this.signature.url = signature.url
      this.signature.presignedURL = signature.presignedURL
    },
    clearSignature() {
      this.signature.file = ''
    },

    submit() {
      this.$emit('submit-submission')
    }
  }
}
</script>

<style></style>
